import { otmsHttp } from '@/utils/http/index.js'

/**
 * 获取订单任务列表
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8718
 */
export function fetchTaskList(data, params) {
    return otmsHttp.request({
        url: '/task/customer/page',
        method: 'post',
        data,
        params,
        noEnterprise:true
    })
}